export const isOneOf = <const T extends readonly unknown[]>(candidate: unknown, allowed: T): candidate is T[number] =>
  allowed.includes(candidate);
